import { t } from '@lingui/core/macro';
import { SBP_MIN_AMOUNT_RUBLES, WALLET_TOPUP_PAYMENT_METHODS } from 'modules/organizer/domain/constants/wallet-topup';
import { WalletTopupPaymentMethod } from 'modules/organizer/domain/interfaces/wallet-topup';
import * as yup from 'yup';

export interface WalletTopupFormValues {
  amount: number;
  email: string;
  paymentMethod: WalletTopupPaymentMethod;
}

// Сообщения — функции: yup зовёт их в момент валидации, с текущим языком.
export const walletTopupFormValidator = yup.object({
  amount: yup
    .number()
    .transform((value, original) => (original === '' || original === null ? undefined : Number(original)))
    .typeError(() => t`Введите сумму`)
    .required(() => t`Введите сумму`)
    .min(SBP_MIN_AMOUNT_RUBLES, () => t`Минимальная сумма — ${SBP_MIN_AMOUNT_RUBLES} ₽`),
  email: yup
    .string()
    .trim()
    .required(() => t`Укажите email для чека`)
    .email(() => t`Укажите корректный email`)
    .max(64, () => t`Email не длиннее 64 символов`),
  paymentMethod: yup
    .string()
    .oneOf([...WALLET_TOPUP_PAYMENT_METHODS], () => t`Выберите способ оплаты`)
    .required(() => t`Выберите способ оплаты`),
});

export interface BuyPlanFormValues {
  planId: number;
}

export const buyPlanFormValidator = yup.object({
  planId: yup
    .number()
    .required(() => t`Выберите тариф`)
    .min(1, () => t`Выберите тариф`),
});
